import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetDynamicSectionDataResponse } from '@/modules/client-setting/type'
import DynamicSectionTable from '../DynamicSectionTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'

interface DynamicSectionListingProps {
	data: GetDynamicSectionDataResponse[]
	total: number
	isLoading?: boolean
}

export default function DynamicSectionListing({
	data,
	total,
	isLoading,
}: DynamicSectionListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.WEB_SETTING,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ตั้งค่าการโชว์ Section"
					description="จัดการการตั้งค่าการแสดงผล Section ต่างๆ บนหน้าเว็บไซต์"
				/>
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/dynamic-section/create-dynamic-section">
							เพิ่มการตั้งค่า Section
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			<DynamicSectionTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
